module.exports = "/wp-content/plugins/farmacy/assets/js/images/account-profile-icon-3aa897fae0f7594d065042addf624bc3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/sidebar/img/account-profile-icon.png
 ** module id = 1001
 ** module chunks = 1 85
 **/